import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	theme => ({
		titleWrap: {
			marginBottom: theme.spacing(9),

			textAlign: 'center',
		},

		title: {},

		image: {
			marginTop: theme.spacing(-10),
			zIndex: 1,
		},

		masonry: {
			columnCount: 1,
			columnGap: theme.spacing(2),

			[theme.breakpoints.up('sm')]: {
				columnCount: ({ columnsNumber }) => (columnsNumber === 1 ? 1 : 2),
			},

			[theme.breakpoints.up('md')]: {
				columnCount: ({ columnsNumber }) => columnsNumber || 3,
				columnGap: theme.spacing(3),
			},
		},
	}),
	{ name: 'Testimonials5-Cards' },
)

export default useStyles
